<template>

  <div
    class="flex-row flex-stretch"
    @mousemove="moveDrag"
    ref="dragSpace"
  >
    <component
      :is="leftComponent"
      :style="{ width: leftWidth }"
      :dragging="dragging"
    />

    <div id="slider" @mousedown="startDrag">
      <dd-icon icon="mdi mdi-dots-vertical color-grey-transparent mr-xxs"/>
    </div>

    <component
      :is="rightComponent"
      :style="{ width: rightWidth }"
      :dragging="dragging"
    />

  </div>
</template>

<script>

export default {
  name: "SlidableComponent.vue",
  props: {
    leftComponent: {
      required: true
    },
    rightComponent: {
      required: true
    },
    leftComponentMinWidth: {
      type: Number,
      required: true
    },
    leftComponentMaxWidth: {
      type: Number,
      required: true
    },
    name:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      leftWidth: this.leftComponentMinWidth,
      rightWidth: undefined,
      dragging: false,
    }
  },
  mounted(){
    const percentage = localStorage.getItem(this.name);
    if ( percentage ) this.leftWidth = this.$refs.dragSpace.offsetWidth * percentage;
    this.setWidths();
  },
  methods: {
    startDrag(){
      this.dragging = true;
      window.addEventListener('mouseup', this.stopDrag);
      document.body.style.userSelect = 'none';
    },
    moveDrag(e){
      if ( this.dragging ) this.setWidths(e.clientX);
    },
    stopDrag(){
      if ( this.dragging ) {
        this.dragging = false;
        window.removeEventListener('mouseup', this.stopDrag);
        document.body.style.userSelect = 'auto';
      }
    },
    setWidths( clientX ){
      if ( clientX ){
        const mouseX = clientX - this.$refs.dragSpace.offsetLeft;
        this.leftWidth = Math.max(this.leftComponentMinWidth, Math.min(mouseX, this.leftComponentMaxWidth)) - 8;
        localStorage.setItem(this.name, (this.leftWidth / this.$refs.dragSpace.offsetWidth));
      }
      this.rightWidth = this.$refs.dragSpace.offsetWidth - this.leftWidth - 16;
    }
  },
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
#slider{
  width: $spacing-md;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#slider:hover{
  cursor: col-resize;
}
#slider:active{
  cursor: ew-resize;
}
</style>
